import styled from 'styled-components'
import { SearchIconSVG } from '../SVGS/SearchIconSVG'
import { SearchButton } from '@src/pages/OutletPage/OutletMenu/MenuItemModal/MenuItemModalAlertStyles'

export const LocationInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  padding: 16px 2px 16px 16px;
  background-color: transparent;
`
export const LocationInputContainer = styled.div`
  border: 2px solid #f0f0f0;
  padding: 0px;
  border-radius: 8px;
  margin: 0px;
  display: flex;
  justify-content: space-between;
`
export const SearchIcon = styled(SearchIconSVG)`
  width: 18px;
  height: 18px;
`
export const LocationSearchButton = SearchButton
